import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module heading/headingcommand
 */
import { Command } from 'ckeditor5/src/core.js';
import { first } from 'ckeditor5/src/utils.js';
/**
 * The heading command. It is used by the {@link module:heading/heading~Heading heading feature} to apply headings.
 */
var HeadingCommand = /*#__PURE__*/function (_Command) {
  _inherits(HeadingCommand, _Command);
  var _super = _createSuper(HeadingCommand);
  /**
   * Creates an instance of the command.
   *
   * @param editor Editor instance.
   * @param modelElements Names of the element which this command can apply in the model.
   */
  function HeadingCommand(editor, modelElements) {
    var _this;
    _classCallCheck(this, HeadingCommand);
    _this = _super.call(this, editor);
    _this.modelElements = modelElements;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(HeadingCommand, [{
    key: "refresh",
    value: function refresh() {
      var _this2 = this;
      var block = first(this.editor.model.document.selection.getSelectedBlocks());
      this.value = !!block && this.modelElements.includes(block.name) && block.name;
      this.isEnabled = !!block && this.modelElements.some(function (heading) {
        return checkCanBecomeHeading(block, heading, _this2.editor.model.schema);
      });
    }
    /**
     * Executes the command. Applies the heading to the selected blocks or, if the first selected
     * block is a heading already, turns selected headings (of this level only) to paragraphs.
     *
     * @param options.value Name of the element which this command will apply in the model.
     * @fires execute
     */
  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      var document = model.document;
      var modelElement = options.value;
      model.change(function (writer) {
        var blocks = Array.from(document.selection.getSelectedBlocks()).filter(function (block) {
          return checkCanBecomeHeading(block, modelElement, model.schema);
        });
        var _iterator = _createForOfIteratorHelper(blocks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            if (!block.is('element', modelElement)) {
              writer.rename(block, modelElement);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);
  return HeadingCommand;
}(Command);
/**
 * Checks whether the given block can be replaced by a specific heading.
 *
 * @param block A block to be tested.
 * @param heading Command element name in the model.
 * @param schema The schema of the document.
 */
export { HeadingCommand as default };
function checkCanBecomeHeading(block, heading, schema) {
  return schema.checkChild(block.parent, heading) && !schema.isObject(block);
}